import type { User } from 'firebase/auth'
import type { Translation } from '../../../translations'

interface ChatUserMenuProps {
    user: User | null
    onLogin: () => Promise<void>
    t: Translation
}

export function ChatUserMenu({
    user,
    onLogin,
    t
}: ChatUserMenuProps) {
    if (!user) {
        return (
            <button
                onClick={onLogin}
                className="text-sm font-medium text-blue-600 transition-colors hover:text-blue-700"
            >
                {t.menuLogin}
            </button>
        )
    }

    return (
        <div className="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-700">
            {user.photoURL ? (
                <img src={user.photoURL} alt="User" className="h-6 w-6 rounded-full object-cover" />
            ) : (
                <div className="flex h-6 w-6 items-center justify-center rounded-full bg-blue-100 text-xs font-bold text-blue-600">
                    {user.email?.[0]?.toUpperCase() || 'U'}
                </div>
            )}
            <span className="max-w-32 truncate">{user.displayName || user.email}</span>
        </div>
    )
}
